export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_pride-37530dd1b91e56b2cfaca561f1a0498f.jpg";